import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

import { useMainStore } from "./stores/main";
import { onMounted, ref } from "vue";
import { Data, MenuButton as MenuButtonType } from "@/types";
import { loadData } from "@/tools/loader";
import Tools from "@/components/tools/Tools.vue";
import Logo from "@/components/Logo.vue";
import { useRoute } from "vue-router";


export default /*@__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const store = useMainStore();

const route = useRoute();

onMounted(() => {
    const url = "/elections.json?v-1";
    loadData(url).then((data: Data) => {
        store.reset();
        store.addMunicipalities(data.municipalities);
        store.addParties(data.parties);
        store.addElections(data.elections);
        store.init = true;
    });
});

const drawer = ref(true);
const menuItems: MenuButtonType[] = [
    {
        text: "Verkiezingskaart",
        to: "/",
    },
    {
        text: "Missie",
        to: "/about",
    },
    {
        text: "Uitleg grid",
        to: "/uitleg-grid",
    },
];

return (_ctx: any,_cache: any) => {
  const _component_v_app_bar_nav_icon = _resolveComponent("v-app-bar-nav-icon")!
  const _component_v_toolbar_title = _resolveComponent("v-toolbar-title")!
  const _component_v_app_bar = _resolveComponent("v-app-bar")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_navigation_drawer = _resolveComponent("v-navigation-drawer")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_v_main = _resolveComponent("v-main")!
  const _component_v_app = _resolveComponent("v-app")!

  return (_openBlock(), _createBlock(_component_v_app, null, {
    default: _withCtx(() => [
      _createVNode(_component_v_app_bar, {
        app: "",
        color: "white",
        dark: ""
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_app_bar_nav_icon, {
            onClick: _cache[0] || (_cache[0] = ($event: any) => (drawer.value = !drawer.value))
          }),
          _createVNode(_component_v_toolbar_title, null, {
            default: _withCtx(() => [
              _createVNode(Logo)
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_v_navigation_drawer, {
        modelValue: drawer.value,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((drawer).value = $event))
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_list, null, {
            default: _withCtx(() => [
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(menuItems, (item) => {
                return _createVNode(_component_v_list_item, {
                  key: item.text,
                  to: item.to,
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (drawer.value = false))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_list_item_title, null, {
                      default: _withCtx(() => [
                        _createElementVNode("b", null, _toDisplayString(item.text), 1)
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _: 2
                }, 1032, ["to"])
              }), 64))
            ]),
            _: 1
          }),
          (_unref(route).name === 'Main')
            ? (_openBlock(), _createBlock(Tools, { key: 0 }))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createVNode(_component_v_main, {
        class: _normalizeClass({ 'main-fixed': _unref(route).name === 'Main' })
      }, {
        default: _withCtx(() => [
          _createVNode(_component_router_view)
        ]),
        _: 1
      }, 8, ["class"])
    ]),
    _: 1
  }))
}
}

})